import { ETS_GROUP_IDS, GOODS_GROUP_IDS, LEASED_ASSET_GROUP_IDS, SOLD_PRODUCT_GROUP_IDS } from '../constants/group-ids'

export function isEtsGroupId(groupId: string): boolean {
  return (ETS_GROUP_IDS as readonly string[]).includes(groupId)
}

export function isLeasedAssetGroupId(groupId: string): boolean {
  return (LEASED_ASSET_GROUP_IDS as readonly string[]).includes(groupId)
}

/** Groups whose Add Emission view offers the purchased/capital goods catalogue. */
export function isGoodsGroupId(groupId: string): boolean {
  return (GOODS_GROUP_IDS as readonly string[]).includes(groupId)
}

/** Groups whose Add Emission view offers the sold-product catalogue (stage-figure basis). */
export function isSoldProductGroupId(groupId: string): boolean {
  return (SOLD_PRODUCT_GROUP_IDS as readonly string[]).includes(groupId)
}
